const sellers = {
  first_name: 'Prénom du vendeur',
  last_name: 'Nom du vendeur',
  company_name: 'Compagnie du vendeur',
};

export default sellers;
